import client from './client'

/*
* params
*   type
*   url
*   data
* */
export default async function (params) {
  const type = params.type ? params.type.toUpperCase() : 'GET'
  const data = params.data || {}
  const headers = params.header || {}
  const {url} = params
  try {
    if (type === 'GET') {
      const res = await client.get(url, {
        headers,
        params: data
      })
      return res.data
    } else if (type === 'POST') {
      const res = await client.post(url, data, headers)
      return res.data
    }
  } catch (err) {
    throw err
  }
}



// WEBPACK FOOTER //
// ./src/apis/root-api/apiAsync.js